export const contentTableConfig = {
  title: '低频访问客户信息',
  propList: [
    {prop: 'channelName', label: '直播间名称', minWidth: '80'},
    {prop: 'deptName', label: '部门名称', minWidth: '80'},
    {prop: 'empName', label: '员工名称', minWidth: '80'},
    {prop: 'consumerWxUnionId', label: '客户微信唯一编号', minWidth: '100'},
    {prop: 'consumerNickName', label: '客户昵称', minWidth: '80'},
    {prop: 'accessTime', label: '访问时间', minWidth: '80'},
    {prop: 'ip', label: '访问ip', minWidth: '80'},
    {prop: 'duration', label: '观看时长:单位秒', minWidth: '80'},
    {prop: 'wechatEmpsStr', label: '客户企微所属业务员', minWidth: '100'},
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
